import React from "react";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";

import { Link } from "react-router-dom";
import { useModelIndex } from "@rhino-project/core/hooks";
import { asKnowledgeRecord, listResults } from "../lib/thirdDoorAdapters";

export default function Resources() {
  const { resources } = useModelIndex("knowledge_record" as any, { limit: 6 } as any);
  const resourceItems = listResults(resources).map(asKnowledgeRecord);
  return (
    <div className="w-full min-w-0 overflow-x-hidden">
      <div className="flex w-full min-w-0 flex-col gap-6">
          <section className="space-y-4">
      <h1 className="text-2xl font-semibold">Resource Hub</h1>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
      {(resourceItems.length ? resourceItems : []).map((item) => (
      <Card key={item.title}>
      <CardHeader><Badge className="w-fit" variant="secondary">Resource</Badge><CardTitle>{item.title}</CardTitle><CardDescription>{item.description}</CardDescription></CardHeader>
      <CardContent><Button asChild variant="outline"><Link to={item.href}>Open</Link></Button></CardContent>
      </Card>
      ))}
      </div>
      </section>
  <section>
      <Card>
      <CardContent className="p-4">
      <Tabs defaultValue="translation">
      <TabsList>
      <TabsTrigger value="translation">Translation</TabsTrigger>
      <TabsTrigger value="readiness">Readiness</TabsTrigger>
      <TabsTrigger value="routing">Routing</TabsTrigger>
      </TabsList>
      <TabsContent value="translation" className="text-sm text-muted-foreground">Use deterministic fallback when AI confidence is low.</TabsContent>
      <TabsContent value="readiness" className="text-sm text-muted-foreground">Sequence clearances and compliance tasks by urgency.</TabsContent>
      <TabsContent value="routing" className="text-sm text-muted-foreground">Coordinate warm handoff with navigator context notes.</TabsContent>
      </Tabs>
      </CardContent>
      </Card>
      </section>
      </div>
    </div>
  );
}